import { SemanticCopyModuleProps } from "@bluebottlecoffee/design-system/components";
import { toHTML } from "@portabletext/to-html";
import { SemanticCopyModule } from "../sanity-schema";

type SemanticCopyTransformerType = {
  data: SemanticCopyModule;
  lang: string;
};

export function toSemanticCopyProps({
  data,
  lang,
}: SemanticCopyTransformerType): SemanticCopyModuleProps {
  return {
    ...(data.sanSerifSubHeadings && {
      sanSerifSubHeadings: data.sanSerifSubHeadings,
    }),
    sections: data.sections.map((section) => ({
      ...(section.heading && { heading: section.heading[lang] }),
      ...(section.headingLevel && { headingLevel: section.headingLevel }),
      ...(section.paragraphs?.length && {
        paragraphs: section.paragraphs.map((p) => toHTML(p[lang])),
      }),
    })),
  };
}
